var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found-content"},[_c('h1',{staticClass:"not-found-title"},[_vm._v("404")]),_c('p',{staticClass:"not-found-message"},[_vm._v("当前地址无效，请点击下方按钮登录系统")]),_c('router-link',{staticClass:"go-home-btn",attrs:{"to":"/"}},[_vm._v("去登录")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }